import React, { useEffect } from "react";
import TradingModeChartWorkspace from "../chartWorkspace/TradingModeChartWorkspace";
import {
  AlpacaPaperAccountOverview,
  AlpacaPaperTicket,
  useAlpacaPaperTradingController,
} from "../paperTrading/AlpacaPaperTradingPanel";
import "./PaperTradingWorkspace.css";
import "./PaperTradingUnifiedLayout.css";

function PaperTradingWorkspace({ sharedSymbol = "" }) {
  const alpacaPaper = useAlpacaPaperTradingController();

  useEffect(() => {
    const cleanSharedSymbol = String(sharedSymbol || "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9.-]/g, "")
      .slice(0, 15);

    if (!cleanSharedSymbol || cleanSharedSymbol === alpacaPaper.symbol) return;

    alpacaPaper.setSymbol(cleanSharedSymbol);
  }, [sharedSymbol, alpacaPaper.symbol, alpacaPaper.setSymbol]);

  return (
    <section className="paperWorkspace" aria-labelledby="paper-workspace-title">
      <div className="paperOnlyBanner" role="status">
        <span aria-hidden="true">!</span>
        ALPACA PAPER ONLY · NO LIVE-MONEY ORDERS
      </div>

      <header className="paperWorkspaceHeader">
        <div>
          <span className="paperEyebrow">PAPER TRADING · ALPACA</span>
          <h1 id="paper-workspace-title">Paper Trading</h1>
          <p>
            Manual paper trading uses the authenticated Alpaca paper account.
            Local sample balances, positions, trade history, and practice
            performance are not shown.
          </p>
        </div>
        <span className="paperSessionBadge">Alpaca paper</span>
      </header>

      <AlpacaPaperAccountOverview controller={alpacaPaper} />

      <div className="paperManualPrimaryGrid">
        <div className="paperManualLeftColumn">
          <AlpacaPaperTicket controller={alpacaPaper} />
        </div>

        <section
          className="paperManualChartPanel"
          aria-labelledby="paper-manual-chart-title"
        >
          <header className="paperManualChartHeader">
            <div>
              <span>PAPER · SHARED PROFESSIONAL CHART</span>
              <h2 id="paper-manual-chart-title">
                {alpacaPaper.symbol} Technical Chart
              </h2>
              <p>
                Authenticated market chart · manual Alpaca paper execution only
              </p>
            </div>
          </header>

          <TradingModeChartWorkspace
            symbol={alpacaPaper.symbol}
            modeLabel="PAPER"
            executionLabel="ALPACA PAPER EXECUTION"
            direction={alpacaPaper.side === "sell" ? "Short" : "Long"}
          />
        </section>
      </div>
    </section>
  );
}

export default PaperTradingWorkspace;
